import { styled } from "@mui/material";

import { CellContainerProps } from "./types";

export const StyledCellContainer = styled("div")<CellContainerProps>`
  width: 100%;
  height: 100%;
  display: flex;
  flex-direction: ${({ direction }) => direction || "row"};
  align-items: center;
  justify-content: ${({ align }) =>
    align === 'center' ? 'center' :
    align === 'end' ? 'flex-end' : 'flex-start'};
  gap: ${({ gap }) => typeof gap === 'number' ? `${gap}px` : gap || '0'};
`;
